export const COLUMN_ORDER = [
    "date",
    "TransactTime",
    "Trade_id",
    "LegRefID",
    "trader",
    "derivatives",
    "volume",
    "symbol_code",
    "Market_ID",
    "contract",
    "start_date",
    "end_date",
    "price",
    "unit",
    "type",
    "marker_tas_type",
    "Blocked",
    "ExecType",
    "OrdStatus",
    "api_company_name",
    "parent_company",
    "clearer",
    "clearing_acct",
    "broker",
    "book",
    "strategy",
    "notes",
    "created_date",
    "updated_at",
    "exchange_type",
    "platform",
];

export const COLUMN_LABELS: Record<string, string> = {
    date: "Date",
    TransactTime: "Transact Time",
    Trade_id: "Trade ID",
    LegRefID: "LegRef ID",
    trader: "Trader",
    derivatives: "Derivatives",
    volume: "Quantity(lots)",
    symbol_code: "Symbol Code",
    Market_ID: "Market ID",
    contract: "Contract",
    start_date: "Pricing From",
    end_date: "Pricing To",
    price: "Price",
    unit: "Unit",
    type: "Type",
    marker_tas_type: "Marker/TAS Type",
    Blocked: "Blocked",
    ExecType: "Exec Type",
    OrdStatus: "Order Status",
    api_company_name: "API Company Name",
    parent_company: "Parent Company",
    clearer: "Clearer",
    clearing_acct: "Clearing Account",
    broker: "Broker",
    book: "Book",
    strategy: "Strategy",
    notes: "Notes",
    created_date: "Created Date",
    updated_at: "Updated At",
    exchange_type: "Exchange Type",
    platform: "Platform",
};